import React, { useEffect } from 'react'
import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import SmallBanner from 'components/SmallBanner'
import { aboutUsContent } from './content/aboutUsContent' 
import { aboutUsBannerContent } from './content/banner.js'

function AboutUs() {
  
  useEffect(() => {
    // Change Tab Title
    document.title = "About Us - Insurance Enterprise"
  }, [])

  return (
    <>

      <SmallBanner content={aboutUsBannerContent} />
      <PageLayout
        content={<SectionLayout content={aboutUsContent} />}
      />

    </>
  )
}

export default AboutUs